<template>
  <div>
    <div class="floating-wrapper" :key="keyTagMultiSelect">
      <Tags
        v-bind:settings="tagifySettings"
        :initialValue="initial"
        :onChange="onTagsChange"
        v-model="searchTagType"
      />
    </div>
  </div>
</template>
<script>
/// green loged in
import apiClientCreator from "../../../../helpers/api/request";
import Tags from "@yaireo/tagify/dist/tagify.vue";

import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "TagsMultiSelect.component",
  components: { Tags },
  props: {
    // categories: { type: Array, required: false },

    initiatedFiltering: {
      type: Boolean,
      required: false,
      default: () => false
    },

    queryObject: {
      type: Object
    },

    options: {
      type: Array,
      required: true,
      default: () => []
    },
    resetList: {
      type: Boolean,
      required: false
    },
    otherFiltering: {
      type: Boolean,
      required: false,
      default: false
    },
    resetClicked: {
      type: Boolean
    }
  },
  computed: {
    ...mapState("tasks", ["resetTags", "categories"]),
    ...mapState("clients", ["filterFromViki"])
  },
  mounted() {
    apiClientCreator(`tasks/category/`)
      .get("")
      .then(res => {
        res.data.map(category => {
          let categoryForView = {};
          categoryForView.value = category.cat_type; // ToDO this goes to the tag to view the 'value' with category name
          categoryForView.code = category;
          this.suggestions.push(categoryForView);

          // this.setInitialCategories(this.categories);
        });
        // this.suggestions.push(category.cat_type);
      })
      .then(res => {
        this.tagifySettings.whitelist.length = 0;
        this.tagifySettings.whitelist.push(...this.suggestions);
      })
      .catch(err => {});
  },
  data() {
    return {
      // initial:'',
      initial: [],
      keyTagMultiSelect: 0,
      temp: [],
      suggestions: [],
      tagifySettings: {
        whitelist: [],
        callbacks: {
          add(e) {},
          focus: e => {},
          remove: e => {
            let tempArr = this.initial.filter(item => {
              return item != e.detail.data.code.cat_type;
            });
            this.initial = tempArr;
            if (e.detail.data.value.length !== 0) {
              let index = this.temp.indexOf(e.detail.data.value);
              this.temp.splice(index, 1);
            }
            let arrOfTagIds = [];
            this.initial.forEach(item => {
              this.suggestions.forEach(catFromSuggestion => {
                if (catFromSuggestion.value == item) {
                  arrOfTagIds.push(catFromSuggestion.code.id);
                }
              });
            });
            // this.$emit("updateTags", this.temp);
            // this.$emit("updateTags", this.initial);
            this.$emit("updateTags", arrOfTagIds);
          }
        }
      },
      // initialCategories: this.setInitialCategories(this.categories),
      infoData: [],
      searchTagType: "",
      result: [],
      showItemsCount: false,
      showOtherFilteringNumber: true,
      tagsStats: [],
      requestAssignBusy: false
    };
  },

  watch: {
    // resetTags: function() {
    //     if (this.resetTags) {
    //       this.temp = '';
    //       this.initial='';
    //       this.$store.commit("tasks/setResetTags", false);
    //     }
    //   },
    filterFromViki:function(){
      if(this.filterFromViki.currentRoute!=="Tasks") return;
      if(this.filterFromViki.filter===''){
         this.resetSelect()
        this.temp=[]
        this.keyTagMultiSelect=0
        this.$emit("updateTags",[])
        return;

      }
      this.temp.push(this.filterFromViki.filter)
      this.onTagsChange(this.temp)
      this.keyTagMultiSelect += 1;
    },
    resetClicked: function() {
      if (this.resetClicked) {
        $(".tagify__tag").empty();
        // this.queryObject.tag_title='';
        this.temp = [];
        this.initial = [];
        // this.suggestions=[];
        //  this.key+=1
      }
    },
    searchTagType: function() {
      if (this.searchTagType) {
        if (this.searchTagType.length > 0) {
          this.filteredType(this.searchTagType);
        }
      }

      if (this.searchTagType === "") {
        this.result = []; //////////////initCat
        this.tagsStats = []; //////////////
        this.$emit("updateTags", this.tagsStats);
      }
    },
    resetList: function() {
      if (this.resetList === true) {
        this.tagsStats = []; /////////////////////////////////
        this.searchTagType = null;
      }
    },
    initiatedFiltering() {
      if (this.initiatedFiltering && this.tagsStats.length > 0) {
        this.tagsStats = [];
      }
    },
    "queryObject.tag_id"() {
      if (this.queryObject.tag_id.length === 0) {
        this.temp = [];
        this.initial = [];
        this.keyTagMultiSelect += 1;
      }
      let tempTagsArray = [];
      this.queryObject.tag_id.forEach(item => {
        let tempTag = this.categories.find(category => {
          return category.id === item;
        });
        tempTagsArray.push(tempTag);
      });
      if (tempTagsArray.length > 0) {
        tempTagsArray.forEach(item => {
          if (this.initial.indexOf(item.cat_type) == -1) {
            this.initial.push(item.cat_type);
            this.keyTagMultiSelect += 1;
          }
        });
      }

      // let tempTag = this.categories.find(category => {
      //   return category.id === this.queryObject.tag_id[0];
      // });
      // if (tempTag) {
      //   if (this.initial.indexOf(tempTag.cat_type) == -1) {
      //     this.initial.push(tempTag.cat_type);
      //     this.keyTagMultiSelect += 1;
      //   }
      // }
    },
    "queryObject.tag_title"() {
      // let tempTag = this.categories.find(category => {
      //   return category.cat_type === this.queryObject.tag_title[this.queryObject.tag_title.length-1];
      // });
      // if (tempTag) {
      //   if (this.initial.indexOf(tempTag.cat_type) == -1) {
      //     this.initial.push(tempTag.cat_type);
      //     this.keyTagMultiSelect += 1;
      //   }
      // }
    }
  },

  methods: {
    // setInitialCategories(initCatArr) {
    //   let initCat = [];
    //   if (initCatArr.length > 0) {
    //     initCatArr.map(category => {
    //       // initCat += category.code.cat_type + ",";
    //       if (category !== undefined && category.code !== undefined) {
    //         if(category.code.cat_type !== undefined){
    //           initCat.push(category.code.cat_type);
    //         } else if(category.code.category.cat_type !== undefined){
    //           initCat.push(category.code.category.cat_type);
    //         }
    //       }
    //     });
    //   }
    //   return initCat;
    // },
    onTagsChange(e) {
      let addedCategories;
      if(e.target){
        if (e.target.value.length !== 0) {
          addedCategories = JSON.parse(e.target.value);
          addedCategories.map(a => {
            if (!this.temp.includes(a.value)) {
              this.temp.push(a.value);
            }
          });
        }
      }


      let arrOfTagIds = [];
      let arrOfTags = []
      this.temp.forEach(item => {
      //    arrOfTags = this.suggestions.filter(sugg=>{
      //     if(sugg.value.toLowerCase()===item.toLowerCase()) return sugg.code.id
      //   })
        this.suggestions.forEach(catFromSuggestion => {
          if (catFromSuggestion.value.toLowerCase() == item.toLowerCase()) {
            arrOfTagIds.push(catFromSuggestion.code.id);
          }
        });
      });

      this.$emit("updateTags", arrOfTagIds);
    },
    filteredType(q) {
      let QArr = q.split(" ");
      this.$emit("updateTags", QArr);
    },

    closeSelect() {
      this.searchTagType = "";
    },
    resetSelect() {
      this.$emit("reset");
      this.closeSelect();
    },

    filterList(q) {
      q = q.replace(/#/g, " ");
      q = q.replace(/\s\s+/g, " ");
      q = q.replace(/[^a-zA-Z0-9 ]/g, "");
      q = q.trim();
      function escapeRegExp(s) {
        return s.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      }
      const words = q
        .split(/\s+/g)
        .map(s => s.trim())
        .filter(s => !!s);
      const hasTrailingSpace = q.endsWith(" ");
      const searchRegex = new RegExp(
        words
          .map((word, i) => {
            if (i + 1 === words.length && !hasTrailingSpace) {
              return `(?=.*\\b${escapeRegExp(word)})`;
            } else {
              return `(?=.*\\b${escapeRegExp(word)}\\b)`;
            }
          })
          .join("") + ".+",
        "gi"
      );
      if (searchRegex.test(q)) {
        this.filteredType(q);
      }
    }
  }
};
</script>

<style scoped>
.floating-wrapper {
  position: relative;
}

ul {
  list-style: none;
  padding-left: 0;
}

li {
  margin: 5px;
  font-size: 9pt;
  text-align: left;
}

li:hover {
  background: #e0e0e0;
  cursor: pointer;
}
.input-main {
  width: 100%;
  position: relative;
  display: inline-block;
  padding: 4px 4px 4px 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: #90a4ae;
  height: 30px;
  border-width: thin;
  overflow: hidden;
  max-width: 100%;
  text-overflow: ellipsis;
  font-size: 8pt;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  box-sizing: border-box;
  margin-top: 3px;
}

input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: searchfield-cancel-button;
}
input[type="text"],
textarea {
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
  /*  padding: 3px 0px 3px 3px;
  margin: 5px 1px 3px 0px;*/
  border: 1px solid #dddddd;
}

input[type="search"]:focus,
textarea:focus {
  box-shadow: 0 0 5px rgba(81, 203, 238, 1);
  /*padding: 3px 0px 3px 3px;*/
  border: 1px solid rgba(81, 203, 238, 1);
}
.label-check-all {
  font-family: "SegoePro-Regular", Arial, sans-serif;
  font-size: 9pt;
  cursor: pointer;
  margin-right: 20px;
}
.all-checkbox {
  vertical-align: middle;
  margin-bottom: 5px;
  margin-right: 5px;
  text-align: left;
}
.dropdown-divider {
  height: 1px;
  margin: 9px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.sum-of-items {
  font-size: 12px;
}

.loader-bottom {
  position: absolute;
  bottom: -5px;
  left: 50%;
}
.tagify {
  /*-webkit-box-flex: 1;*/
  /*-ms-flex: 1;*/
  /*flex: 1;*/
  /*display: block;*/
  /*min-width: 110px;*/
  /*margin: 5px;*/
  /*padding: .3em .5em;*/
  /*padding: var(--tag-pad,.3em .5em);*/
  /*line-height: inherit;*/
  /*position: relative;*/
  /*white-space: pre-line;*/
  /*overflow-y: hidden !important;*/
  /*overflow-x: auto !important;*/
  /*max-height: 30px !important;*/
}
</style>
